import React from "react";
import { ToggleGroup, ToggleGroupItem } from "../ui/toggle-group";
import { BrainIcon } from "lucide-react";
import { ViewMode } from "../../types/tradingJournal";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

interface ViewToggleProps {
  view: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const ViewToggle = ({ view, onViewChange }: ViewToggleProps) => {
  return (
    <TooltipProvider>
      <ToggleGroup
        type="single"
        value={view}
        onValueChange={(value) => value && onViewChange(value as ViewMode)}
        className="bg-white/5 border border-white/10 rounded-lg p-1"
      >
        <Tooltip>
          <TooltipTrigger asChild>
            <ToggleGroupItem
              value="behavior"
              aria-label="Behavior view"
              className="rounded-md data-[state=on]:bg-white/10 data-[state=on]:text-white"
            >
              <BrainIcon className="h-4 w-4 mr-2" />
              Behavior
            </ToggleGroupItem>
          </TooltipTrigger>
          <TooltipContent>
            <p>Track your trading psychology and behaviors</p>
          </TooltipContent>
        </Tooltip>
      </ToggleGroup>
    </TooltipProvider>
  );
};

export default ViewToggle;
